import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { StringUtil } from '@univacity/shared/util';
import { Menu } from '../../interfaces';
import { RouterFragmentService } from '../../services';

@Component({
  selector: 'un-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavComponent {
  @Input() menus: Menu[];
  @Input() useFragmentService?: boolean;
  @Input() noWrap?: boolean;
  @Input() layout?: 'horizontal' | 'vertical' = 'horizontal';

  @Output() linkClick = new EventEmitter<string | string[] | void>();

  constructor(public fragmentService: RouterFragmentService) {}

  isExternalUrl(url?: string | string[]) {
    return StringUtil.isExternalUrl(url);
  }
}
